'use strict';

angular.module('app.entity.certcopy', [
    'sharecrf-sdk',
])
    .component('recordCertcopy', {
        templateUrl: 'modules/ecrd/components/certcopy/content.html',
        controller: 'RecordCertcopyController',
    });
